import { isNightOffMeal, nightOffLabel } from '../../utils/nightOff.js'

/**
 * Lifecycle badge for assigned planner meals (past / cooked / skipped / night off).
 */
export default function MealSlotStatusBadge({ meal, className = 'meal-row-slot-status' }) {
  if (!meal) return null
  if (isNightOffMeal(meal)) {
    return (
      <span className={`${className} night-off`}>
        {nightOffLabel(meal.nightOffType)}
      </span>
    )
  }
  if (meal.status === 'cooked') {
    return <span className={`${className} cooked`}>Cooked</span>
  }
  if (meal.status === 'skipped') {
    return <span className={`${className} skipped`}>Skipped</span>
  }
  if (meal.isPast) {
    return <span className={`${className} past`}>Past</span>
  }
  return null
}
